<div class="download-icon-container absolute top-[122px] ml-auto sm:right-15 sm:pl-0">
  <button mat-icon-button [matMenuTriggerFor]="customColumnMenu">
    <mat-icon
      id="customizeColumns"
      data-test-id="independent-credits-custom-columns-button"
      matTooltip="Customize table columns"
      [svgIcon]="'heroicons_outline:cog-8-tooth'"
    ></mat-icon>
  </button>
  <mat-menu
    #customColumnMenu="matMenu"
    yPosition="below"
    [class]="
      'bg-card relative -ml-0 mt-4 min-w-fit overflow-visible rounded-[10px] border border-gray-300 p-4 py-2 shadow-none'
    "
    ><app-custom-column [updateTableCallback]="updateTableCallback" [inputColumns]="customColumns"></app-custom-column>
  </mat-menu>
</div>
<div>
  <tilled-table
    [data]="(independentCreditsViewModel$ | async)!"
    [getPageCallback]="getIndependentCredits"
    [dataLength]="independentCreditsCount$ | async"
    data-test-id="independent-credits-table"
    [noDataMainText]="'No independent credits found'"
    [noDataSecondaryText]="secondaryReasonText"
    [getClickCallback]="rowClickedCallback"
    [hideColumnKeys]="hideColumnKeys"
    [sortColumnKeys]="sortColumnKeys"
    [scrollable]="true"
    [showDisplayedColumnsDropdown]="false"
    [startingPageIndex]="pageIndex"
    [startingPageLimit]="pageSize"
  ></tilled-table>
</div>
